// Shared: company and organisation addresses render side by side, and local copies would drift.
export function formatAddress(entity: {
  addressLine1?: string | null;
  city?: string | null;
  postalCode?: string | null;
}): string | null {
  const parts = [entity.addressLine1, entity.city, entity.postalCode].filter(Boolean);
  return parts.length > 0 ? parts.join(", ") : null;
}
